export const format = (pattern, ...args) => {
  return pattern.replace('{}', args[0]);
  // Split on '{}', return formatted string with <> <> and components.
};